import { DataGrid } from "@mui/x-data-grid";
import "./styles.css";
import { Stack, Typography, Box } from "@mui/material";

const createColumns = (
  rows: RowObject[],
  selectedAgentColumn: string | undefined,
  selectedHHColumn: string | undefined,
) => {
  const columnNames = Object.keys(rows[0]).filter(
    (key) => key !== "mui_row_id" && isNaN(Number(key)), // remove numeric keys
  );

  return columnNames.map((item, index) => {
    const isHHSelected =
      selectedHHColumn !== undefined && selectedHHColumn === item;
    const isAgentSelected =
      selectedAgentColumn !== undefined && selectedAgentColumn === item;
    const highlightAgentClass = isAgentSelected ? "highlight-column-agent" : "";
    const highlightHHClass = isHHSelected ? "highlight-column-hh" : "";
    return {
      field: item,
      headerName: item,
      width: 150,
      headerClassName: highlightAgentClass || highlightHHClass,
      cellClassName: highlightAgentClass || highlightHHClass,
    };
  });
};

export default function FileDataTable({
  rows,
  selectedAgentColumn,
  selectedHHColumn,
}: {
  rows: RowObject[];
  selectedAgentColumn: string | undefined;
  selectedHHColumn: string | undefined;
}) {
  return (
    <Box sx={{ border: "1px solid #ededed", borderRadius: 2 }}>
      <Stack>
        <Stack paddingLeft={2} paddingTop={1} style={{ background: "#ededed" }}>
          <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
            Data Preview
          </Typography>
        </Stack>
        <Stack>
          <DataGrid
            rows={rows}
            columns={createColumns(rows, selectedAgentColumn, selectedHHColumn)}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
            getRowId={(row) => row.mui_row_id}
            style={{ height: "100%", width: "100%" }}
            sx={{
              border: "none",
              "& .MuiDataGrid-main": {
                border: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                borderBottom: "none",
                backgroundColor: "#ededed", // ✅ Set column header background
                borderRadius: 0,
              },
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
